<template>
  <div class="acc-cla">
    <zkThreeRow>
      <div slot="search">
        <el-form
          :model="form"
          ref="ruleForm"
          class="demo-ruleForm"
          :inline="true"
        >
          <el-form-item :label="$t('witnessRecord.beginEndTime')" prop="time">
            <el-date-picker
              class="pickData_cla"
              v-model="value2"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="-"
              :start-placeholder="$t('common.startTime')"
              :end-placeholder="$t('common.endTime')"
              :picker-options="pickerOptions"
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('witnessRecord.accEvent')" prop="event">
            <el-select
              v-model="form.event"
              :placeholder="$t('common.chooseOptions')"
              clearable
            >
              <el-option
                v-for="(item, index) in accEventType"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Sn" prop="sn">
            <el-input v-model="form.sn"></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('witnessRecord.operatorPerson')"
            prop="operator"
          >
            <el-input v-model="form.operator"></el-input>
          </el-form-item>
          <el-form-item label=""
            ><el-button type="primary" @click="onSearch">{{
              $t('operation.search')
            }}</el-button></el-form-item
          >
        </el-form>
      </div>
      <div slot="table">
        <zk-table :data="tableData" :columns="column" :showTableMenu="true">
          <span slot="tableTip">
            <span class="normal-cla"
              ><span class="base-circle"></span
              >{{ $t('witnessRecord.normalEvent') }}</span
            >
            <span class="warn-cla">
              <span class="base-circle"></span
              >{{ $t('witnessRecord.warnEvent') }}
            </span>
            <span class="error-cla"
              ><span class="base-circle"></span
              >{{ $t('witnessRecord.abnormalEvent') }}</span
            >
          </span>
        </zk-table>
        <div class="pagination-margin-top">
          <el-pagination
            background
            @size-change="pageSizeChange(arguments[0], getAccRecordList)"
            @current-change="curPageChange(arguments[0], getAccRecordList)"
            :current-page="pager.curPage"
            :page-size="pager.pageSize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="pager.total"
          ></el-pagination>
        </div>
        <verify-photo ref="verifyPhoto"></verify-photo>
      </div>
    </zkThreeRow>
  </div>
</template>

<script>
import { getStartTime, getEndTime } from '@/utils/utils.js'
import { getAccRecordList } from '@/services/attendanceApi'
import pickerOptions from '@/utils/pickerOptions.js'

export default {
  data() {
    return {
      pickerOptions: pickerOptions(this),
      value2: [],
      accEventType: [
        {
          label: this.$t('witnessRecord.normalEvent'),
          value: 'normal',
          class: 'normal-cla'
        },
        {
          label: this.$t('witnessRecord.warnEvent'),
          value: 'warning',
          class: 'warn-cla'
        },
        {
          label: this.$t('witnessRecord.abnormalEvent'),
          value: 'abnormal',
          class: 'error-cla'
        }
      ],
      form: {
        startTime: '',
        endTime: '',
        event: '',
        sn: '',
        operator: ''
      },
      tableData: [],
      column: [
        {
          label: 'Sn',
          prop: 'sn'
        },
        {
          label: this.$t('witnessRecord.doorNum'),
          prop: 'doorNum'
        },
        {
          label: this.$t('witnessRecord.operatorPerson'),
          prop: 'operator',
          render: (h, params) => {
            if (params.row.operator) {
              return h('span', {}, params.row.operator)
            } else {
              return h('span', {}, 'N/A')
            }
          }
        },
        {
          label: this.$t('witnessRecord.time'),
          prop: 'time'
        },
        {
          label: this.$t('witnessRecord.outInStatus'),
          prop: 'inOutType',
          render: (h, params) => {
            if (params.row.inOutType) {
              return h('span', {}, params.row.inOutType)
            } else {
              return h('span', {}, 'N/A')
            }
          }
        },
        {
          label: this.$t('witnessRecord.doorEvent'),
          prop: 'eventType',
          render: (h, params) => {
            if (params.row.eventType) {
              return h(
                'span',
                {
                  class: {
                    'error--color': params.row.eventMold === 'abnormal',
                    ' warn--color': params.row.eventMold === 'warning',
                    'normal--color': params.row.eventMold === 'normal'
                  }
                },
                params.row.eventType
              )
            } else {
              return h('span', {}, 'N/A')
            }
          }
        },
        {
          label: this.$t('witnessRecord.temperature'),
          prop: 'temperature',
          visiable: true,
          render: (h, params) => {
            if (
              params.row.temperature === '255' ||
              params.row.temperature === undefined ||
              params.row.temperature === ''
            ) {
              return h('span', {}, 'N/A')
            }
            return h(
              'span',
              {
                class:
                  parseInt(params.row.temperature) >= 37.3
                    ? 'error--color'
                    : 'normal--color'
              },
              params.row.temperature
            )
          }
        },
        {
          label: this.$t('witnessRecord.hasMask'),
          prop: 'maskFlag',
          visiable: true,
          render: (h, params) => {
            if (
              params.row.maskFlag === undefined ||
              params.row.maskFlag === '' ||
              params.row.maskFlag === '255'
            ) {
              return h('span', {}, 'N/A')
            }
            let res =
              params.row.maskFlag === '0'
                ? this.$t('witnessRecord.no')
                : this.$t('witnessRecord.yes')
            return h('span', {}, res)
          }
        },
        {
          label: this.$t('witnessRecord.checkMode'),
          prop: 'verified',
          visiable: true,
          render: (h, params) => {
            if (params.row.verified === undefined) {
              return h('span', {}, 'N/A')
            }
            return h('span', {}, params.row.verified)
          }
        },
        {
          label: this.$t('attendanceRecord.verifyPhoto'),
          prop: 'verifyPhoto',
          render: (h, params) => {
            if (params.row.verifyPhoto === undefined || params.row.verifyPhoto === '') {
              return h('span')
            } else {
              return h(
                'span',
                {
                  style: {
                    color: '#4db22f',
                    cursor: 'pointer'
                  },
                  on: {
                    click: () => {
                      this.$refs.verifyPhoto.showPhotoDia(params.row.verifyPhoto)
                    }
                  }
                },
                this.$t('attendanceRecord.view')
              )
            }
          }
        }
      ]
    }
  },
  methods: {
    onSearch() {
      this.pager.curPage = 1
      this.getAccRecordList()
    },
    getAccRecordList() {
      let valueLength = this.value2 && this.value2.length === 2
      this.form.startTime = valueLength
        ? getStartTime(this.value2[0]) / 1000
        : ''
      this.form.endTime = valueLength
        ? parseInt(getEndTime(this.value2[1]) / 1000)
        : ''
      if (sessionStorage.getItem('role') === '"developer"') {
        this.form.appKey = this.$root.appKey
      }
      let params = {
        params: this.form,
        pager: this.pager
      }
      getAccRecordList(params)
        .then(data => {
          if (data.code === '00000000') {
            this.tableData = data.payload.results
            this.pager.total = data.payload.totalRecords
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => this.errorMessage())
    }
  },
  mounted() {
    this.showLoad()
    this.$nextTick(() => {
      let _self = this
      let t = setTimeout(() => {
        _self.getAccRecordList()
        _self.closeLoad()
        clearTimeout(t)
      }, 500)
    })
    this.value2 = []
    let firstDate = new Date()
    firstDate.setDate(1)
    let currentData = new Date()
    this.value2.push(firstDate)
    this.value2.push(currentData)
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
/deep/ .el-table__row {
  .error--color {
    color: @ststusFailed;
  }
  .normal--color {
    color: @statusSuccess;
  }
  .warn--color {
    color: @statusWarning;
  }
}

.acc-cla {
  .base-circle {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin: 0 10px;
  }
  .error--color {
    color: @ststusFailed;
  }
  .normal--color {
    color: @statusSuccess;
  }
  .warn--color {
    color: @statusWarning;
  }
  .warn-cla {
    .warn--color;
    span {
      background: @statusWarning;
    }
  }
  .normal-cla {
    .normal--color;
    span {
      background: @statusSuccess;
    }
  }
  .error-cla {
    .error--color;
    span {
      background: @ststusFailed;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/enterpriseSetting/accRecord.vue